import { useCallback } from 'react';
import {
  useQuery,
  useSuspenseQuery,
  QueryResult,
  useLazyQuery,
  useApolloClient,
  QueryOptions,
  QueryHookOptions,
  SuspenseQueryHookOptions,
  LazyQueryHookOptions,
  LazyQueryExecFunction
} from '@apollo/client';
import { useSnackbarHelper } from '../../useSnackbarHelper';
import QUERY from '../operations/EngagementPostTrafficSource.graphql';
import { Query, QueryengagementPostTrafficSourceArgs } from '../../__generated__/globalTypes';

export const useEngagementPostTrafficSourceQuery = (
  options?: QueryHookOptions<Query, QueryengagementPostTrafficSourceArgs>
) => {
  const { t, enqueueSnackbar } = useSnackbarHelper();
  const result = useQuery<Query, QueryengagementPostTrafficSourceArgs>(QUERY, {
    onError: (error) => {
      enqueueSnackbar(t(error.message), { variant: 'error' });
    },
    ...options
  });

  return result;
};

export const useEngagementPostTrafficSourceLazyQuery = (
  options?: LazyQueryHookOptions<Query, QueryengagementPostTrafficSourceArgs>
): QueryResult<Query, QueryengagementPostTrafficSourceArgs> & {
  getEngagementPostTrafficSource: LazyQueryExecFunction<Query, QueryengagementPostTrafficSourceArgs>;
} => {
  const { t, enqueueSnackbar } = useSnackbarHelper();
  const [getEngagementPostTrafficSource, result] = useLazyQuery<Query, QueryengagementPostTrafficSourceArgs>(QUERY, {
    onError: (error) => {
      enqueueSnackbar(t(error.message), { variant: 'error' });
    },
    ...options
  });

  return { getEngagementPostTrafficSource, ...result };
};

export const useEngagementPostTrafficSourcePromiseQuery = () => {
  const client = useApolloClient();

  const getEngagementPostTrafficSource = useCallback(
    (options?: Omit<QueryOptions<QueryengagementPostTrafficSourceArgs, Query>, 'query'>) =>
      client.query<Query, QueryengagementPostTrafficSourceArgs>({ ...options, query: QUERY }),
    [client]
  );

  return { getEngagementPostTrafficSource };
};
// Suspense Query Hooks
export const useEngagementPostTrafficSourceSuspenseQuery = (
  options?: SuspenseQueryHookOptions<Query, QueryengagementPostTrafficSourceArgs>
) => {
  const result = useSuspenseQuery<Query, QueryengagementPostTrafficSourceArgs>(QUERY, {
    ...options
  });

  return result;
};
